// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package24CircleFilled: FC<Package24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-1-15.425v9.15L8 21.7a1.948 1.948 0 0 1-1-1.725V11.95l8 4.625Zm9 5.125-7 4.025v-9.15l8-4.625v8.025a1.948 1.948 0 0 1-1 1.725Zm-.075-11.45-2.95 1.725-7.95-4.575L15 6.275c.317-.183.65-.275 1-.275s.683.092 1 .275l6.925 3.975Zm-4.95 2.9L16 14.85l-7.95-4.575 3-1.725 7.925 4.6Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Package24CircleFilled;
